import type { AdminTypes } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../../../utility/client';

export const generateExternalApiKey = async () => {
  const res = await Api.post<AdminTypes.CreateExternalApiKeyResponse>(
    '/admin/v1/external-api',
  );

  return res.data;
};
